module.exports = __webpack_public_path__ + "static/img/advisory.51ea67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advisory.png
// module id = sVNx
// module chunks = 5